<div class="clearfix">
  <div class="flex justify-end">
    <button mat-raised-button color="accent" (click)="editIssueTicket()">
      <mat-icon>add</mat-icon>
      Add Issue
    </button>
  </div>
</div>

<ng-container *ngIf="(issueTicketCaseLinkDataSource && issueTicketCaseLinkDataSource?.filteredData.length>0);
                          then showIssuesTicketTable else emptyIssuesTicketTable">
</ng-container>

<ng-template #showIssuesTicketTable>
  <form [formGroup]="formGroup">
    <table class="w-100" mat-table matSort
           [dataSource]="issueTicketCaseLinkDataSource"
           #MatSortIssueStep="matSort">

      <ng-container [matColumnDef]="tableColumns.ICONS">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon class="mat-primary-color hand-cursor" matTooltip="EDIT Issue"
                    (click)="editIssueTicket(row)">edit
          </mat-icon>
          
          <ng-container *ngIf="isAuthorizedToDeleteIssue()">
            <mat-icon *ngIf="row?.issueTicketDTO" class="mat-primary-color hand-cursor" matTooltip="DELETE Issue"
                      (click)="deleteIssueTicketCaseConfirmation($event, row)">delete
            </mat-icon>
          </ng-container>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ISSUE_TICKET_ID">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.issueTicketId}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.NAME">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.REPORTER">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Reported By</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.reporter?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ASSIGNEE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Assigned To</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.assignee?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.STATUS">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>status</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.status?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.RESOLUTION">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Resolution</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.resolution?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PRIORITY">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Priority</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.priority?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.MODULE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Module</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.module?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.START_DATE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.startDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.DUE_DATE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Due Date</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.dueDate | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.END_DATE">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
        <td *matCellDef="let row" mat-cell>{{row.issueTicketDTO?.endDate | date: dateFormat}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="issueTicketCasesDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: issueTicketCasesDisplayedColumns;"></tr>
    </table>

    <mat-paginator #MatPaginatorIssueStep="matPaginator"
                   [pageIndex]="paginatorControls.pageNumber"
                   [pageSize]="paginatorControls.pageSize"
                   [pageSizeOptions]="paginatorControls.pageSizeOptions">
    </mat-paginator>

    <ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
  </form>
</ng-template>

<ng-template #emptyIssuesTicketTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No Issues exists</label>
  </div>
  <ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
</ng-template>

<ng-template #PrevAndNextButtons>
  <div class="button-container">
    <button mat-raised-button matStepperPrevious color="primary">Back</button>
    <button mat-raised-button matStepperNext color="primary">Next</button>
  </div>
</ng-template>
